import { render, staticRenderFns } from "./ListHistoryBankAccountComponent.vue?vue&type=template&id=755a88f4&"
import script from "./ListHistoryBankAccountComponent.vue?vue&type=script&lang=js&"
export * from "./ListHistoryBankAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListHistoryBankAccountComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports